import { render, staticRenderFns } from "./AuthView.vue?vue&type=template&id=78d0650c&"
import script from "./AuthView.vue?vue&type=script&lang=ts&"
export * from "./AuthView.vue?vue&type=script&lang=ts&"
import style0 from "./AuthView.vue?vue&type=style&index=0&id=78d0650c&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports